<script>
export default {
  props: ['titleName'],
  template: `
    <div class="pageHeader">
      <div class="pageHeader-content content">
       <h2>{{ titleName }}</h2>
      </div>
    </div>
  `,
  data () {
    return {
      show: false
    }
  }
}
</script>

<style scoped lang="scss">
@import './../styles/definitions.scss';
.pageHeader {
  background-color: $kHeaderColorMain;
  margin: 0 0;
  height: $PageHeaderHeight;
  background-image: url(../assets/alpha-stella_bg.png);
  border-bottom: 2px solid rgba(0, 0, 0, 0.712);
  &-content {
    font-size: 32px;
    letter-spacing: 0.3em;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageHeader.vue